<template>
  <div>
    <div class="index-box index-5" v-if="isMore">
      <div class="index-title">
        越来越多的企业组织都在使用领筑云
      </div>
      <div class="container">
        <img src="~@/assets/imgs/case-6.png" style="width: 100%;" alt="" />
      </div>
    </div>
    <div class="index-box index-6" v-if="!hidePartner">
      <div class="index-title">
        90,000+企业的信赖之选
      </div>
      <div class="container">
        <img src="~@/assets/imgs/partner.png" style="width: 100%;" alt="" />
      </div>
    </div>
    <div class="index-7">
      <div class="index-7-title">领筑云-让工程更省心</div>
      <div class="d-flex align-items-center justify-content-center">
        <svg-icon name="icon-phone"></svg-icon>
        <span>4000-996-660</span>
        <el-button
          round
          type="primary"
          style="padding: 11px 20px; border-radius: 50px; font-size: 24px; width: 196px;"
          plain
          @click="initDialog"
          >申请使用</el-button
        >
      </div>
    </div>
    <div class="view-footer">
      <div class="container">
        <div class="d-flex">
          <div class="view-footer-column" v-for="item in list" :key="item.title">
            <div class="view-footer-title">
              {{ item.title }}
            </div>
            <div
              class="view-footer-item view-footer-item-link"
              @click="openUrl(cItem.url)"
              v-for="cItem in item.children"
              :key="cItem.title"
            >
              {{ cItem.title }}
            </div>
          </div>
          <div class="view-footer-column flex-fill">
            <div class="view-footer-title">
              联系我们
            </div>
            <div class="view-footer-item">
              全国统一服务热线：4000-996-660
            </div>
            <div class="view-footer-item">
              深圳领筑科技有限公司
            </div>
            <div class="view-footer-item">
              公司地址：深圳市南山区艺园路202号马家龙文体中心B栋8楼
            </div>
          </div>
          <img src="~@/assets/imgs/qrcode.png" class="view-footer-qrcode" alt="" />
        </div>
        <div class="view-footer-copyright">
          © Copyright 2012-2022 深圳智慧建设科技有限公司
          <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备19073496号</a> <svg-icon></svg-icon> 粤公网安备
          44030502004117号
        </div>
      </div>
    </div>
    <apply-for-use ref="applyForUse"></apply-for-use>
  </div>
</template>

<script>
// import api from '@/api'
import { mapState } from 'vuex'
import applyForUse from '@/modules/common/applyForUse'
import config from '@/config'
export default {
  name: 'App',
  data() {
    return {
      list: [
        {
          title: '关于我们',
          children: [
            {
              title: '公司简介',
              path: '',
              url: config.api.domain + '/lzsite/#/about'
            },
            {
              title: '使命愿景价值观',
              path: '',
              url: config.api.domain + '/lzsite/#/about'
            },
            {
              title: '发展历程',
              path: '',
              url: config.api.domain + '/lzsite/#/about'
            },
            {
              title: '客户端下载',
              path: '',
              url: config.api.domain
            }
          ]
        },
        {
          title: '服务',
          children: [
            {
              title: '工程经营解决方案',
              path: '',
              url: config.api.domain + '/lzsite/#/solutionProject'
            },
            {
              title: '供应链解决方案',
              path: '',
              url: config.api.domain + '/lzsite/#/supplyChains'
            },
            {
              title: '劳务解决方案',
              path: '',
              url: config.api.domain + '/lzsite/#/labour'
            },
            {
              title: '金融解决方案',
              path: '',
              url: config.api.domain + '/lzsite/#/finance'
            },
            {
              title: '协同办公解决方案',
              path: '',
              url: config.api.domain + '/lzsite/#/synergy'
            }
          ]
        },
        {
          title: '友情链接',
          children: [
            {
              title: '智慧控股官网',
              url: 'http://www.zhihuikg.com/'
            },
            {
              title: '领筑招采平台',
              url: 'http://www.lingzhubuy.com/'
            },
            {
              title: '消防天下官网',
              url: 'http://www.119tx.com/'
            }
          ]
        }
      ]
    }
  },
  methods: {
    init() {},
    initDialog() {
      this.$refs.applyForUse.init()
    },
    openUrl(url) {
      window.open(url)
    }
  },
  computed: {
    ...mapState([])
  },
  props: {
    hidePartner: {
      type: Boolean,
      default: false
    },
    isMore: {
      type: Boolean,
      default: false
    }
  },
  components: { applyForUse },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init(to, from)
    })
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    next()
  }
}
</script>

<style scoped lang="scss">
$primary: #4876f9;
.index-5 {
  background: url(~@/assets/imgs/case-5.png) no-repeat;
  background-size: cover;
}
.index-6 {
  background: url(~@/assets/imgs/index-6-1.png) no-repeat;
  background-size: cover;
}

.index-7 {
  background: url(~@/assets/imgs/index-7-1.png) no-repeat;
  background-size: 100%;
  padding: 60px 0 80px;
  color: white;

  .index-7-title {
    font-size: 35px;
    margin-bottom: 30px;
    color: white;
    text-align: center;
  }

  span {
    font-size: 35px;
    margin-right: 30px;
  }

  .icon {
    font-size: 33px;
    margin-right: 10px;
  }
}

.view-footer {
  background: #2f313d;
  padding: 45px 0 10px;

  .view-footer-title {
    font-size: 14px;
    color: #ececec;
    margin-bottom: 10px;
  }
  .view-footer-item {
    color: #848692;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .view-footer-item-link:hover {
    cursor: pointer;
    color: #fff;
  }

  .view-footer-copyright {
    color: #646676;
    text-align: center;
    border-top: 1px solid #3d4050;
    font-size: 14px;
    padding: 15px 0;
    margin-top: 30px;

    a {
      color: #646676;
      text-decoration: none;

      &:hover {
        color: lighten(#646676, 10);
      }
    }
  }
}
.view-footer-column {
  margin-right: 70px;
}

.view-footer-qrcode {
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/viewFooter.vue